/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {AdTagGeneratorPageComponent} from './ad-tag-generator-page.component';


export function adTagStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state('app.ad-tag', {
          url: '/ad-tag?auId&auW&auH&design&auName',
          views: {
            'content@app': {
              component: AdTagGeneratorPageComponent
            },
            'title@app': stateTitleView()
          },
          data: {
            title: "Ad Tag Generator and Tester"
          }
        });
  }, adnRouterHelper);
}
